import { useMutation, useQuery, useQueryClient } from "react-query";
import useApiHelper from "../services/useApiHelper";

export default function useMetaSingle(agencyId, pageId) {
  const staleTime = 1000 * 60 * 2; // 2 minutes
  const queryClient = useQueryClient();
  const { get, post, put, del } = useApiHelper();

  const metaPageConfig = useQuery(["meta", agencyId, pageId], () => get(`/meta/${agencyId}/${pageId}/single`), {
    staleTime,
  });

  
  const update = useMutation((pageConfig) => put(`/meta/${pageConfig.id}`, pageConfig), {
    onSuccess: () => {
      queryClient.invalidateQueries(["meta", agencyId])
    },
  });

  const remove = useMutation((pageConfigId) => del(`/meta/${pageConfigId}`, null), {
    onSuccess: () => {
      queryClient.invalidateQueries(["meta", agencyId])
    },
  });

  return {
    metaPageConfig,
    update,
    remove
  };
}
